import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import BomProcessRow from './BomProcessRow'
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormTitle from '../../../../library/form/components/FormTitle';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../library/layout/Index";

const BomProcess = (props) => {
    const { formObject, viewData, masterKeys } = props;
    // console.log('BomProcessRow 1', viewData);
    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span><FormTitle formObject={formObject} masterKeys={masterKeys} value="Add BOM Process" /></span>
                </UiTitle>
                <UiAction>
                    <FormButton formObject={formObject} ksc="p" rowKey=""
                            action={{ actionId: "new", actionName: "bomProcessAdd", actionParam: {actionType : "copyProcess"}, containerKey: "popup" }}
                            className='uiActionButton' text={<SarasTrans value="Copy Process" />}></FormButton>
                    <FormButton formObject={formObject} ksc="p" rowKey=""
                        action={{ actionId: "new", actionParam: {}, containerKey: "popup" }}
                        className='uiActionButton' text={<SarasTrans value="Add Process" />}></FormButton>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <ul className="uiListTable">
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                            <li className="uiColumnCenter uiColumn200"><SarasTrans value="Process Name" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Cost Formula" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Unit" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Time" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Process Cost" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="OH Cost" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Est. Val." /></li>
                            <li className="uiColumnCenter uiColumn200"><SarasTrans value="Remark" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Outsourced" /> </li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Sequence" /> </li>
                            <li className="uiColumnCenter uiColumn60"><SarasTrans value="Action" /> </li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                            <li><BomProcessRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                        ))
                    }
                </ul>
            </UiViewContent>
            <div className='uiRow' style={{marginTop:'100px'}}>
                    <div className="uiCol">
                        <div>
                            <span className='uiSeq uiFProcess'><span><SarasTrans value = "N"/></span></span>
                            <span><SarasTrans value = "Sequence number of this process"/></span>
                        </div>
                    </div>
                </div>

        </UiView>
    )
}

export default withView(BomProcess, "bomProcess", "bomHeader");